import { DefaultButton, IButtonProps, PrimaryButton } from "@fluentui/react";
import { useEffect, useRef, useState } from "react";

interface ISafetyButton extends IButtonProps {
    activationDelay?: number
}

const SafetyButton = (props: ISafetyButton) => {
    const { activationDelay, ...buttonProps } = props;

    const [left, setLeft] = useState(activationDelay ?? 3);

    useEffect(() => {

        let timer: NodeJS.Timeout | null = null;

        if (left > 0)
            timer = setInterval(() => {

                setLeft(time => {
                    if (time > 0)
                        return time - 1;
                    else {
                        if (timer)
                            clearInterval(timer);
                        return 0;
                    }
                });

            }, 1000);

        return () => {
            if (timer)
                clearInterval(timer);
        }

    }, []);

    return <PrimaryButton
        {...buttonProps}
        disabled={buttonProps.disabled || left > 0}
        text={!buttonProps.disabled && left - 0
            ? `${buttonProps.text ?? ''} (${left})`
            : buttonProps.text
        }
    />;
}

export default SafetyButton;